export default class Render {
    constructor(Component) { this.Component = Component }
    async product() {
        const title = [this.Component.container.dataset.forcedTitle ?? this.Component.values.name];
        if (this.Component.values.ratingMean || this.Component.score.ratingMean)
            title.push(this.Component.Layout.Template.score);

        this.Component.Layout.title     = title.join(' ');
        this.Component.Layout.buttons   = this.Component.quickBuy ? await this.Component.Layout.Template.price() : this.Component.Layout.Template.buttons;
        if (!this.Component.hasImage() && this.Component.values.image)
            this.Component.image = this.Component.values.image;
        if (this.Component.hints)
            this.Component.Layout.hints = this.Component.Layout.Template.hints;
        if (this.Component.Buttons.hasPriceLayout())
            this.Component.Layout.setPrice(await this.Component.Layout.Template.price());
        if (this.Component.container.dataset.layout !== 'small' && this.Component.badge > 0) {
            this.Component.addRenderBlockingPromise(App.Endpoint.Badges.get);
            let template = await this.Component.Layout.Template.badge;
            if (template) this.Component.Layout.badge = template;
        }
        // Reference price
        const offer = await this.Component.values.Offer;
        if (offer && offer.priceMarketing && offer.referencePriceFormatted !== 'null' &&
            this.Component.Layout.reference) {
            this.Component.Layout.reference = await this.Component.Layout.Template.reference();
        }
        this.Component.Bar.render();

        // From here on, force render if empty
        if (!this.Component.hasImage() && this.Component.values.image)
            this.Component.image = this.Component.values.image;
        this.renderEmptyUrls();
    }
    renderEmptyUrls() {
        this.Component.container.querySelectorAll('[href=""]')
            .forEach(element => {
                element.href = App.Route('shop.product') + this.Component.values.id;
            });
    }
}
